import { useTranslation } from 'react-i18next';
import Select from '../atoms/select';
import { getLocale, languageOptions, setLocale } from '../../lib/locale';
import { useMemo } from 'react';
import classNames from 'classnames';

interface LanguageSelectProps {
	className?: string;
	modoEscuro?: boolean;
}

const LanguageSelect = ({ className, modoEscuro }: LanguageSelectProps) => {
	const { i18n, t } = useTranslation();

	const currentLanguage = useMemo(
		() =>
			languageOptions.find((lang) => lang.key === getLocale()) ??
			languageOptions[0],
		[]
	);

	const handleLanguageChange = (selectedLabel: string) => {
		const selectedLanguage = languageOptions.find(
			(lang) => lang.label === selectedLabel
		);

		if (selectedLanguage && selectedLanguage.key !== i18n.language) {
			setLocale(selectedLanguage.key);
			window.location.reload();
		}
	};

	return (
		<Select
			className={classNames('w-48', className)}
			boxClassName={classNames({
				'!border-[#34404e] !bg-[#1d232c] !text-white hover:!border-[#2b94ff]':
					modoEscuro,
			})}
			name="language"
			options={languageOptions.map((lang) => lang.label)}
			icons={languageOptions.map((lang) => lang.icon)}
			value={currentLanguage.label}
			onChange={(e) => handleLanguageChange(e.target.value)}
			menuClassName={classNames({
				'!border-[#34404e] !bg-[#151a21] !text-white shadow-[0_18px_40px_rgba(0,0,0,0.45)]':
					modoEscuro,
			})}
			optionClassName={classNames({
				'!text-white': modoEscuro,
			})}
			optionItemClassName={classNames({
				'hover:!bg-[#263342]': modoEscuro,
			})}
			optionItemSelectedClassName={classNames({
				'!bg-[#263342]': modoEscuro,
			})}
			placeholderClassName={classNames({
				'!text-white': modoEscuro,
			})}
			title={t('locale.select')}
		/>
	);
};

export default LanguageSelect;
